import { useEffect, useRef, useState } from "react";

import { SpaceImage, SpaceLocation } from "~/components/shared/Space";
import { currency } from "~/lib/utils";

import { Button } from "../ui";

function CopyInput({ value }: { value: string }) {
    const ref = useRef<HTMLInputElement | null>(null);

    const [isCopied, setIsCopied] = useState(false);

    function copyCode() {
        if (ref && ref.current) {
            ref.current.select();
            ref.current.setSelectionRange(0, 99999);
            navigator.clipboard.writeText(ref.current.value);
            setIsCopied(true);
        }
    }

    useEffect(() => {
        let copyTimeout: NodeJS.Timeout;
        if (isCopied) {
            copyTimeout = setTimeout(() => {
                setIsCopied(false);
            }, 2000);
        }

        return () => {
            clearTimeout(copyTimeout);
        };
    }, [isCopied]);

    return (
        <>
            <section className="flex items-center h-10 gap-4">
                <input
                    ref={ref}
                    type="text"
                    value={value}
                    className="flex flex-1 justify-center px-2 text-sm md:text-base outline-none bg-muted h-full rounded cursor-pointer"
                    readOnly
                    onClick={copyCode}
                />
                <Button variant="outline" onClick={copyCode}>
                    Copy Link
                </Button>
            </section>
            <div className="w-full h-6 text-right">
                {isCopied && <p className="text-sm text-green-800">Link copied successfully!</p>}
            </div>
        </>
    );
}

export function ShareSpace({ baseUrl, space }: { baseUrl: string; space: Space }) {
    return (
        <div className="flex flex-col items-start gap-6">
            <div className="flex flex-row items-start gap-8">
                <SpaceImage className="w-32 lg:w-44" src={space.thumbnail} size="sm" />
                <section className="flex-1 flex flex-col flex-1 items-start gap-4">
                    <div className="flex flex-col gap-1">
                        <h2 className="capitalize text-2xl font-title">{space.section}</h2>
                        <p className="opacity-60">
                            <SpaceLocation {...space} />
                        </p>
                    </div>
                    <p className="capitalize text-xl ">{currency(space.price)}</p>
                </section>
            </div>
            <section className="flex flex-1 w-full flex-col gap-2">
                <h2 className="text-sm">Share link</h2>
                <CopyInput value={`${baseUrl}/map?spaceId=${space.lotSellUnitId}`} />
            </section>
        </div>
    );
}
